import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AllegatiMovimenti } from 'src/app/models/allegati-movimenti';

@Injectable({
  providedIn: 'root',
})
export class AllegatiMovService {
  private http = inject(HttpClient);

  allegatiUrl = environment.ildatoArticoliDpi + 'api/allegati/movimenti';

  list(): Observable<AllegatiMovimenti[]> {
    return this.http.get<AllegatiMovimenti[]>(this.allegatiUrl);
  }

  listByMovimento(idMov: number): Observable<AllegatiMovimenti[]> {
    return this.http.get<AllegatiMovimenti[]>(
      this.allegatiUrl + '/bymov/' + idMov,
    );
  }

  filtered(
    idArticolo = 0,
    idDipendente = 0,
    progr = 0,
    daData: Date = null,
    aData: Date = null,
    firmato: boolean = null,
  ): Observable<AllegatiMovimenti[]> {
    let filter = '';
    if (idArticolo != null && idArticolo > 0) {
      filter += 'IdArticolo=' + idArticolo + '&';
    }
    if (idDipendente != null && idDipendente > 0) {
      filter += 'IdDipendente=' + idDipendente + '&';
    }
    if (progr != null && progr > 0) {
      filter += 'Progr=' + progr + '&';
    }
    if (daData != null) {
      filter += 'DaData=' + daData.toJSON() + '&';
    }
    if (aData != null) {
      filter += 'AData=' + aData.toJSON() + '&';
    }
    if (firmato != null) {
      filter += 'Firmato=' + firmato + '&';
    }
    if (filter.length > 0) {
      filter = '?' + filter.slice(0, -1).trim();
    }
    return this.http.get<AllegatiMovimenti[]>(
      this.allegatiUrl + '/filtered' + filter,
    );
  }

  delete(idAllegato: number): Observable<AllegatiMovimenti> {
    return this.http.delete<AllegatiMovimenti>(
      this.allegatiUrl + '/' + idAllegato,
    );
  }

  allega(idMov: number, nome: string, data: FormData): Observable<number> {
    return this.http.post<number>(
      this.allegatiUrl + '/newallegato/' + idMov + '/' + nome,
      data,
    );
  }

  scarica(id: number): Observable<Blob> {
    return this.http.get(this.allegatiUrl + '/getallegato/' + id, {
      responseType: 'blob',
    });
  }

  getImmagine(id: number): Observable<string> {
    return this.http.get(this.allegatiUrl + '/getimmagine/' + id, {
      responseType: 'text',
    });
  }
}
